export enum SuperOpsStateKey {
  // Document-related states
  BrowseTemplateModalActiveTemplateId = 'templates.browseTemplateModal.activeTemplateId',
  BrowseTemplateModalActiveOwnerType = 'templates.browseTemplateModal.activeOwnerType',
  BrowseTemplateModalDocumentType = 'templates.browseTemplateModal.documentType',
  EditOrCloneDocumentDrawerMode = 'documents.editOrCloneDocumentDrawer.mode',
  IsCreateDocumentModalVisible = 'documents.createDocumentModal.visible',
  IsZCreateDocumentModalVisible = 'documents.zCreateDocumentModal.visible',
  IsTemplateModalVisible = 'templates.templateModal.visible',
  TemplateModalActiveForm = 'templates.templateModal.activeForm',
  TemplateModalCurrentTemplatePage = 'templates.templateModal.currentTemplatePage',
  SaveTemplateModalVisible = 'templates.saveTemplateModal.visible',
  SaveTemplateModalTemplateName = 'templates.saveTemplateModal.templateName',
  UpdateStatusModalOpen = 'documents.updateStatusModal.open',
  UpdateStatusModalNewDocumentStatus = 'documents.updateStatusModal.newDocumentStatus',
}

class StateRegistry {
  private registry = new Map<SuperOpsStateKey, any>();
  private listeners = new Map<SuperOpsStateKey, Set<(value: any) => void>>();

  register(key: SuperOpsStateKey, value: any): void {
    const oldValue = this.registry.get(key);
    this.registry.set(key, value);
    
    // Notify listeners if value changed
    if (oldValue !== value) {
      const keyListeners = this.listeners.get(key);
      if (keyListeners) {
        keyListeners.forEach(listener => listener(value));
      }
    }
  }

  unregister(key: SuperOpsStateKey): void {
    this.registry.delete(key);
  }

  get(key: SuperOpsStateKey): any {
    return this.registry.get(key);
  }

  getAll(): Record<string, any> {
    const result: Record<string, any> = {};
    this.registry.forEach((value, key) => {
      result[key] = value;
    });
    return result;
  }

  clear(): void {
    this.registry.clear();
  }

  // Subscribe to changes for a specific key
  subscribe(key: SuperOpsStateKey, listener: (value: any) => void): () => void {
    if (!this.listeners.has(key)) {
      this.listeners.set(key, new Set());
    }
    
    this.listeners.get(key)!.add(listener);
    
    // Return unsubscribe function
    return () => {
      const keyListeners = this.listeners.get(key);
      if (keyListeners) {
        keyListeners.delete(listener);
        if (keyListeners.size === 0) {
          this.listeners.delete(key);
        }
      }
    };
  }
}

export const stateRegistry = new StateRegistry();